import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmacionRoutingModule } from './confirmacion-routing.module';
import { ConfirmacionComponent } from './confirmacion.component';

@NgModule({
  declarations: [ConfirmacionComponent], // ✅ Declarado aquí
  imports: [CommonModule, ConfirmacionRoutingModule],
  exports: [ConfirmacionComponent] // ✅ Exportar el componente si se usa en otro módulo
})
export class ConfirmacionModule {}
